export default __webpack_public_path__ + "images/dark-blue-arrow.png?826ad7f1eb682c40290d1cfdc24a3c08";